// extracted by mini-css-extract-plugin
export default {"caption_wrapper":"X3_z6fl59Bmjz44WLxr2","caption_link":"pDijWZuNGC_GLJIOF0Nk","caption_item":"bTFWLIlOck9NTa7Tsm_A","span":"L4yWZ0ToQmq7wNwHvrmi"};